import { useState, useEffect } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { AiFillInstagram, AiFillTwitterSquare, AiFillGithub } from 'react-icons/ai'
import { IoLogoFacebook } from 'react-icons/io'
import Share from 'common/share'
import AuthorInfo, { AuthorStyled } from './author-info'

const AuthorResponsive = styled(AuthorStyled)`
  @media (min-width: 768px) {
    .author-name {
      margin-right: 8px;
    }
    .author-avatar {
      height: 32px;
      width: 32px;
    }
    .author-info {
      display: flex;
      align-items: center;
    }
    .author-container {
      width: 32px;
      height: 32px;
    }
  }
`

const AuthorSectionStyled = styled.div`
  margin: 32px 0;
  font-family: var(--primaryFont);
  .social-icons {
    display: flex;
    margin-bottom: 39px;
  }
  .social-icon {
    margin-right: 24px;
  }
  svg {
    fill: var(--white);
  }
  @media(min-width: 768px) {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
    margin: 48px 0;
    .social-icons {
      margin-bottom: 0px;
    }
  }
`

function Author({
  name, photo, social, date, title, resume, duration,
}) {
  const [url, setUrl] = useState('')
  useEffect(() => {
    setUrl(window.location.href)
  }, [])
  return (
    <AuthorSectionStyled id="author">
      <div className="social-icons">
        {social.github && (
          <a className="social-icon" target="_blank" rel="noopener noreferrer" href={social.github}>
            <AiFillGithub size={25} />
          </a>
        )}
        {social.instagram && (
          <a className="social-icon" target="_blank" rel="noopener noreferrer" href={social.instagram}>
            <AiFillInstagram size={25} />
          </a>
        )}
        {social.twitter && (
          <a className="social-icon" target="_blank" rel="noopener noreferrer" href={social.twitter}>
            <AiFillTwitterSquare size={25} />
          </a>
        )}
        {social.facebook && (
          <a className="social-icon" target="_blank" rel="noopener noreferrer" href={social.facebook}>
            <IoLogoFacebook size={25} />
          </a>
        )}
        <Share url={url} title={title} text={resume} position="bottomRight" />
      </div>
      <AuthorResponsive>
        <AuthorInfo photo={photo} name={name} date={date} duration={duration} />
      </AuthorResponsive>
    </AuthorSectionStyled>
  )
}

Author.propTypes = {
  name: PropTypes.string.isRequired,
  photo: PropTypes.string.isRequired,
  social: PropTypes.shape({
    facebook: PropTypes.string,
    instagram: PropTypes.string,
    twitter: PropTypes.string,
  }).isRequired,
  date: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  resume: PropTypes.string.isRequired,
  duration: PropTypes.number.isRequired,
}

export default Author
